import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid";
import { useState } from "react";
import { DashboardCalendarEventTooltip } from "./event-tooltip";

function DashboardMeetingCalendar({ onStartAndEndDateChange, events }: any) {
  const [openEventId, setOpenEventId] = useState<string | null>(null);

  return (
    <>
      <FullCalendar
        height={650}
        headerToolbar={{
          left: "prev,next",
          right: "today",
          center: "title",
        }}
        buttonText={{
          today: "Today",
        }}
        datesSet={(arg) => {
          onStartAndEndDateChange(arg);
        }}
        plugins={[dayGridPlugin]}
        initialView="dayGridMonth"
        events={events}
        eventContent={(e: any) => {
          const eventId = String(e.event.id || e.event._def.extendedProps?.iId);
          return (
            <DashboardCalendarEventTooltip
              title={e.event._def.title}
              event={e.event._def.extendedProps}
              isOpen={openEventId === eventId}
              onOpen={() => setOpenEventId(eventId)}
              onClose={() =>
                setOpenEventId((current) => (current === eventId ? null : current))
              }
            />
          );
        }}
      />
    </>
  );
}

export { DashboardMeetingCalendar };
